// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".navbar[data-v-2579c226]{margin-left:10px;margin-right:10px}#no-background[data-v-2579c226]:before{background-color:transparent!important}.avatar-item[data-v-2579c226]{display:float;top:3px;left:18px}.img[data-v-2579c226]{width:26px}.ankeri-logo[data-v-2579c226]{width:100px}.v-container[data-v-2579c226]{max-width:1344px!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
